module.exports = __webpack_public_path__ + "img/step5.74a4fc87.png";